import React from 'react';
import { css } from '@emotion/core';
import ImageThumbnail from '../../../shared/ImageThumbnail/ImageThumbnail';
import { ga4SelectPromotion } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxSelectPromotion } from '../../../shared/lib/farmakomMetrics';
import Slider from 'react-slick';
import './TagDiscounts.scss';

const TagDiscounts = ({
  loading = false,
  tags,
  discountsTitle,
  primaryColor,
  hasGoogleAnalytics4Advanced,
  hasFarmakomMetrics,
  discountTagsVersion,
}) => {
  const onClick = tag => {
    if (hasGoogleAnalytics4Advanced) {
      // GA4 SELECT PROMOTION
      ga4SelectPromotion(tag);
    }
    if (hasFarmakomMetrics) {
      // FKMX SELECT PROMOTION
      fkmxSelectPromotion(tag);
    }
  };

  const tagsToShow =
    !!tags && !!tags.length
      ? tags.length > 3
        ? tags
        : [...tags, ...tags]
      : [];

  const settings = {
    arrows: false,
    dots: false,
    customPaging: function(i) {
      return !!withThumbnails ? (
        <a />
      ) : (
        <button className="dot">{/* {i + 1} */}</button>
      );
    },

    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    speed: 500,
    slidesToShow:
      discountTagsVersion === 1
        ? Math.min(5, tagsToShow.length)
        : discountTagsVersion !== 1
        ? Math.min(5, tagsToShow.length)
        : null,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow:
            discountTagsVersion === 1
              ? Math.min(4, tagsToShow.length)
              : discountTagsVersion !== 1
              ? Math.min(4, tagsToShow.length)
              : null,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow:
            discountTagsVersion === 1
              ? Math.min(3, tagsToShow.length)
              : discountTagsVersion !== 1
              ? Math.min(3, tagsToShow.length)
              : null,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: Math.min(2, tagsToShow.length),
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: Math.min(2, tagsToShow.length),
          centerPadding: '10%',
        },
      },
      {
        breakpoint: 431,
        settings: {
          slidesToShow: Math.min(1, tagsToShow.length),
          centerPadding: '10%',
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: Math.min(1, tagsToShow.length),
          centerPadding: '10px',
        },
      },
    ],
  };

  const tagDiscountStyle = css`
    .image-container {
      @media screen and (max-width: 600px) {
        height: 480px;
      }
    }
    &.version-1 {
      .slick-slider {
        margin: 0 auto;
        .slick-list {
          margin: 0;

          @media screen and (min-width: 600px) {
            // padding: 0 10% 0 5% !important;
          }

          @media screen and (min-width: 992px) {
            padding: 0 20% 0 10% !important;
          }
          .slick-track .slick-slide {
            width: 80%;
            margin: 0 auto;

            @media screen and (min-width: 768px) {
              width: 60%;
            }
          }
        }
      }
    }
    &.version-2,
    &.version-3 {
      .slick-slider {
        margin: 0 auto;
        .slick-list {
          padding: 0px;
          @media screen and (min-width: 855px) {
            // padding: 20px;
            padding: 0px;
          }
        }
      }
    }
  `;

  return (
    <div className="tag-discounts">
      <div
        className={
          discountTagsVersion === 1
            ? 'container-fluid'
            : 'container-version-2-3'
        }
      >
        <div
          className={`tag-discounts version-${discountTagsVersion}`}
          css={tagDiscountStyle}
        >
          <Slider
            {...settings}
            fullWidth
            loading={loading}
            title={discountsTitle}
            primaryColor={primaryColor}
          >
            {tags &&
              tagsToShow.map(tag => {
                return (
                  <ImageThumbnail
                    key={tag.id}
                    image={tag.imageUrl}
                    url={`/tag/${tag.seoName}`}
                    onClick={() => onClick(tag)}
                    discountTagsVersion={discountTagsVersion}
                  />
                );
              })}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default TagDiscounts;
//discountTagsVersion 1: infinite sliders towards both left and right side of the page, max 4 slides;
//discountTagsVersion 2: centered slider, max 4 slides.
